import { gql } from '@generated/gql';

const selectBhcQuoteMutation = gql(`
  mutation SelectBhcQuote($input: SelectQuoteInput!) {
    selectQuote(input: $input) {
      id
      monthlyCost {
        value
      }
      quotes {
        id
        totalMonthlyCost {
          value
        }
        selected
        product {
          id
          name
          type
          subtype
        }
      }
    }
  }
`);

const deselectBhcQuoteMutation = gql(`
  mutation DeselectBhcMutation($input: DeselectQuoteInput!) {
    deselectQuote(input: $input) {
      id
    }
  }
`);

export { selectBhcQuoteMutation, deselectBhcQuoteMutation };
